import { render, staticRenderFns } from "./WechatMiniLogin.vue?vue&type=template&id=6d6aeed2&"
import script from "./WechatMiniLogin.vue?vue&type=script&lang=js&"
export * from "./WechatMiniLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports